let InsuranceService = function (Restangular) {
  const Service = Restangular.all('admin/insurance');


  let save = (resource) => {
    if (resource.save) {
      return Service.customPUT({
        "descricao": resource.descricao,
        cobre_analises_clinicas: resource.cobre_analises_clinicas,
        cobre_exames_imagem: resource.cobre_exames_imagem,
        cobre_vacinas: resource.cobre_vacinas,
        city_id: resource.city_id,
        "id": resource.id
      }, "convenios")
    } else {
      return Service.customPOST({
        "descricao": resource.descricao,
        "cidade": resource.city,
        cobre_analises_clinicas: resource.cobre_analises_clinicas,
        cobre_exames_imagem: resource.cobre_exames_imagem,
        cobre_vacinas: resource.cobre_vacinas,
        "validade": resource.validade
      }, "convenios")
    }
  }

  let saveState = (resource) => {
    if (resource.save) {
      return Service.customPUT({
        "description": resource.description,
        "uf": resource.uf,
        "id": resource.id
      }, "states")
    } else {
      return Service.customPOST({
        "description": resource.description,
        "uf": resource.uf,
        "id": resource.id
      }, "states")
    }
  }
  let saveCity = (resource) => {
    if (resource.save) {
      return Service.customPUT({
        "description": resource.description,
        "sigla": resource.sigla,
        "uf": resource.uf,
        "id": resource.id
      }, "cities")
    } else {
      return Service.customPOST({
        "description": resource.description,
        "uf": resource.uf,
        "sigla": resource.sigla
      }, "cities")
    }
  }

  let index = (SIGLA, query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Service.customGET(`${SIGLA}/convenios?like_search=${query.like_search}`)
  }

  let load = (sigla, query) => {
    query = query || {};
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
      let count = 10;
      index(sigla, query)
        .then(data => {
          resolve({count, data});
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  let listStates = () => {
    return Service.customGET(`states`)
  }
  let listCities = (UF) => {
    return Service.customGET(`states/${UF}/cities`)
  }
  let show = (id) => {
    return Service.get(id);
  }

  let deleteCovenant = (resource) => {
    return Service.customDELETE("convenios/planos", {
      "id": resource.id,
      "sigla_city": resource.sigla_city,
      "sigla_uf": resource.sigla_uf
    })
  }

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  }

    return {index, load, save, show, destroy, listStates, listCities, saveState, saveCity, deleteCovenant};
};

InsuranceService.$inject = ['Restangular'];

export default InsuranceService;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance.service.js